import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useServiceCenter } from '../../hooks/use-service-center';
import { FilterBarInputOpt, FilterGroup } from '../../models/utilities/filter-bar';
import { AutoCompleteInput, DateInput, DealerInput, InputLabel, TextInput, ToggleInput } from '../form-elements/_index';

// #region Component Props 

interface IProps {
    filterModel : FilterGroup;
    // TODO: figure out the signature
    onModelChange : any;
    onApplyFilter: any;
    classes?        : string;
}

// #endregion

const FilterBarGroupExpanded = (props : IProps) => {

    const dispatch = useDispatch();
    const [isGroupOpen, setIsGroupOpen] = React.useState(false);
    const userServiceCenter = useServiceCenter();

    const onKeyDownHandler = (e: any) => {

        if (e.keyCode === 13) {
           props.onApplyFilter();
        }
        
    };

    const onDropdownSelectionHandler = (name : string, e : any, value: string, type: any) => {
        console.log(e);

        const selectedIdx = e.target.selectedIndex;
        const selectedOpt = e.target.options[selectedIdx];
        const selectedUuid = selectedOpt.dataset.optid;

        props.onModelChange(name, selectedUuid, value, type);
    };

    const getDropdownSelectedValue = (model : FilterGroup) => {
        
        let currVal;
        for(let i = 0; i < model.opts.length; i++) {
            if(model.opts[i].data) {
                currVal = model.opts[i].data;
                break;
            }
        }

        return currVal ? currVal : undefined;
    };

    const buildInput = () => {

        switch(props.filterModel.type) {
            case "checkboxes": 
                const a = props.filterModel.opts.map((itm : FilterBarInputOpt) => 
                    <div className="filter-cb-option" key={`fbcb-${itm.uuid}`}>
                        <input 
                            className="form-check-input" 
                            type="checkbox" 
                            checked={ itm.data }
                            onChange={() => props.onModelChange(
                                props.filterModel.name,
                                itm.uuid,
                                !itm.data,
                                props.filterModel.type
                            )}
                            id={ `filter-input-cb-${ itm.uuid }` } />
                        <label
                            className="form-check-label"
                            htmlFor={ `filter-input-cb-${ itm.uuid }` }>
                            { itm.label }
                        </label>
                    </div>                 
                );

                return <div className="checkbox-filter-group">
                        <label>{ props.filterModel.name }</label>
                        { a }
                    </div>;
            case "text":             
                return <TextInput
                            type="text"
                            id="filterBarText"
                            label={ props.filterModel.name }
                            onKeyDown={ onKeyDownHandler }
                            onChange={(e : any) => props.onModelChange(
                                props.filterModel.name, 
                                props.filterModel.opts[0].uuid, 
                                e.target.value,
                                props.filterModel.type
                            )}
                            placeholder={ props.filterModel.opts[0].label }
                            value={ props.filterModel.opts[0].data } />;
            case "numeric":             
                return <TextInput
                            type="number"
                            id="filterBarNumber"
                            label={ props.filterModel.name }
                            onKeyDown={ onKeyDownHandler }
                            onChange={(e : any) => props.onModelChange(
                                props.filterModel.name, 
                                props.filterModel.opts[0].uuid, 
                                e.target.value,
                                props.filterModel.type
                            )}
                            placeholder={ props.filterModel.opts[0].label }
                            value={ props.filterModel.opts[0].data } />;           
            case "dealer":
                return <DealerInput
                            id={`search-input-${ props.filterModel.uuid }`}
                            dispatch={ dispatch }
                            label={ props.filterModel.name }
                            onChange={(e: any) => props.onModelChange(
                                props.filterModel.name,
                                props.filterModel.opts[0].uuid,
                                e.id,
                                props.filterModel.type
                            )}
                            value={ props.filterModel.opts[0].data }
                        />;
            case "date": 
                return <DateInput
                            id="startDate"
                            label={ props.filterModel.name }
                            value={ props.filterModel.opts[0].data }
                            onChange={(e: any) => props.onModelChange(
                                props.filterModel.name,
                                props.filterModel.opts[0].uuid,
                                e,
                                props.filterModel.type
                            )}
                        />;
            case "autocomplete":
                return <AutoCompleteInput
                            id={`search-input-${ props.filterModel.uuid }`}
                            label={ props.filterModel.name }
                            dispatch={ dispatch }
                            onChange={(e: any) => props.onModelChange(
                                props.filterModel.name,
                                props.filterModel.opts[0].uuid,
                                e,
                                props.filterModel.type
                            )}
                            suggestionRender={ props.filterModel.autoCompleteRender }
                            value={ props.filterModel.opts[0].data }
                            placeholder={ props.filterModel.name }
                            endpoint={ props.filterModel.autoCompleteEndpoint.formattify(userServiceCenter.name) } 
                        />;
            case "readonly": 
                return <div>
                        <input 
                            type="number" 
                            className="form-control readonly-filter"
                            readOnly={true}
                            placeholder={ props.filterModel.opts[0].label }
                            value={ props.filterModel.opts[0].data } 
                            onKeyDown={ onKeyDownHandler }
                            onChange={(e) => props.onModelChange(
                                props.filterModel.name, 
                                props.filterModel.opts[0].uuid, 
                                e.target.value,
                                props.filterModel.type
                            )}
                        />
                    </div>;
            case "toggle":
                return <ToggleInput
                            id={ `filter-toggle-${ props.filterModel.uuid }` }
                            name={ `filter-toggle-${ props.filterModel.uuid }` }
                            label={ props.filterModel.name }
                            checked={ props.filterModel.opts[0].data === true }
                            onClick={() => props.onModelChange(
                                props.filterModel.name,
                                props.filterModel.opts[0].uuid,
                                props.filterModel.opts[0].data !== true,
                                props.filterModel.type
                            )}
                        />;
            case "dropdown":
                return <div className="form-group">
                        <InputLabel>
                            { props.filterModel.name }
                        </InputLabel>
                        <select
                            name={ name }
                            className="form-control"
                            value={ getDropdownSelectedValue(props.filterModel) } 
                            onChange={(e) => onDropdownSelectionHandler(
                                props.filterModel.name, 
                                e, 
                                e.target.value,
                                props.filterModel.type
                            )}>
                            <option id={undefined}>Choose...</option>
                            {
                                props.filterModel.opts.map((itm: FilterBarInputOpt) => (
                                    <option data-optid={itm.uuid}  key={itm.uuid} value={itm.qsValue}>{itm.label}</option>
                                ))
                            }
                        </select>
                    </div>;
            default:
                return null;
        }
    };    

    return <div className="col">
                { buildInput() }
        </div>;
};

FilterBarGroupExpanded.defaultProps = {
    classes: ''
};

export { FilterBarGroupExpanded };
